export default {
      id: "pen-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#pen",
      toString: function () {
        return this.url;
      }
    }